import { useEffect, useState } from "react";

const cachedScripts = new Map<string, boolean>();

const useGlobalScript = (src: string) => {
  const [state, setState] = useState({
    loaded: false,
    error: false,
  });

  useEffect(() => {
    if (cachedScripts.get(src)) {
      setState({
        loaded: true,
        error: false,
      });
    } else {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;

      // Optimistically mark the script as loaded
      cachedScripts.set(src, true);

      const onScriptLoad = () => {
        setState({
          loaded: true,
          error: false,
        });
      };

      const onScriptError = () => {
        // Remove from cachedScripts as it was optimistically set to loaded
        cachedScripts.delete(src);
        script.remove();

        setState({
          loaded: true,
          error: true,
        });
      };

      script.addEventListener("load", onScriptLoad);
      script.addEventListener("error", onScriptError);

      document.body.appendChild(script);

      return () => {
        script.removeEventListener("load", onScriptLoad);
        script.removeEventListener("error", onScriptError);
      };
    }
  }, [src]);

  return [state.loaded, state.error];
};

export default useGlobalScript;
